import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxModule } from 'primeng/checkbox';
import { AvanoErrorBoxComponent } from './avano-error-box.component';
import { AvanoInfoBoxComponent } from './avano-info-box.component';
import { AvanoWarningBoxComponent } from './avano-warning-box.component';

@NgModule({
  declarations: [
    AvanoInfoBoxComponent,
    AvanoWarningBoxComponent,
    AvanoErrorBoxComponent
  ],
  imports: [
    CommonModule, TranslateModule.forChild({ extend: true }), CheckboxModule, FormsModule
  ],
  exports: [
    AvanoInfoBoxComponent,
    AvanoWarningBoxComponent,
    AvanoErrorBoxComponent]
})
export class AvanoBoxModule { }
